<app-userapi-shared-non-oauth [userApi]="userApi">

  <p [innerHTML]="userApi.api.configDescription"></p>

  <FloatingLabelInput
      id="publicKey"
      class="form-label"
      [label]="(userApi.api.placeholder1 | translate) || 'API Key'"
      [appColor]="appColor()"
      [(myValue)]="userApi.publicKey"
      (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.privateKey">
  </FloatingLabelInput>

  <FloatingLabelInput
      id="privateKey"
      class="form-label"
      [label]="(userApi.api.placeholder2 | translate) ||'API Secret'"
      [appColor]="appColor()"
      [(myValue)]="userApi.privateKey"
      (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.privateKey">
  </FloatingLabelInput>

</app-userapi-shared-non-oauth>